var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 7.5C9.33333 6.00883 10.5272 4.8 12 4.8C13.4728 4.8 14.6667 6.00883 14.6667 7.5C14.6667 8.99117 13.4728 10.2 12 10.2C10.5272 10.2 9.33333 8.99117 9.33333 7.5ZM12 3C9.5454 3 7.55556 5.01472 7.55556 7.5C7.55556 9.98528 9.5454 12 12 12C14.4546 12 16.4444 9.98528 16.4444 7.5C16.4444 5.01472 14.4546 3 12 3ZM8.44444 13.8C7.2657 13.8 6.13524 14.2741 5.30175 15.118C4.46825 15.9619 4 17.1065 4 18.3V20.1C4 20.5971 4.39797 21 4.88889 21C5.37981 21 5.77778 20.5971 5.77778 20.1V18.3C5.77778 17.5839 6.05873 16.8972 6.55883 16.3908C7.05892 15.8845 7.7372 15.6 8.44444 15.6H15.5556C16.2628 15.6 16.9411 15.8845 17.4412 16.3908C17.9413 16.8972 18.2222 17.5839 18.2222 18.3V20.1C18.2222 20.5971 18.6202 21 19.1111 21C19.602 21 20 20.5971 20 20.1V18.3C20 17.1065 19.5317 15.9619 18.6983 15.118C17.8648 14.2741 16.7343 13.8 15.5556 13.8H8.44444Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.d4688a2f.svg";
export { ForwardRef as ReactComponent };